var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowSideColorGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n\t.st1{fill:none;}\n\t.st2{fill:#353A3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.1,2.9L7.1,2.9c0.5-0.5,1.3-0.5,1.8,0c0,0,0,0,0,0l8.4,8.4c0.4,0.4,0.4,1,0,1.4l-8.4,8.4 c-0.5,0.5-1.3,0.5-1.8,0c0,0,0,0,0,0l0,0c-0.5-0.5-0.5-1.3,0-1.8c0,0,0,0,0,0l7.3-7.3L7.1,4.7C6.6,4.2,6.6,3.4,7.1,2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSideColorGray);
export default __webpack_public_path__ + "static/media/icon-arrow-side-color-gray.c0f48b58.svg";
export { ForwardRef as ReactComponent };